import { defineRecipe } from '@plurall/elo-v3';

/**
 * Shared base grid for theme card sections.
 * Use this as the base for all section/page grids that display theme cards.
 * For grids that need layout/spacing variants (e.g. the search page), define
 * those variants in the consuming recipe file and spread this base.
 */
export const themeCardGridBase = {
  '--preferred-card-width': '248px',
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(var(--preferred-card-width), 1fr))',
  gap: 'gap.large',
  lg: {
    '--preferred-card-width': '340px',
  },
} as const;

export const themeCardGridRecipe = defineRecipe({
  className: 'theme-card-grid',
  base: themeCardGridBase,
});
